import {
  Button,
  Grid,
  Typography,
  withStyles,
  WithStyles,
  Theme,
  Hidden,
  CircularProgress,
} from '@material-ui/core'
import { Fragment, useState } from 'react'
import { UpdateStatus } from '../../../actions/types'
import { DeleteShowingArgs } from '../../../services/showings'
import { BucketObject } from '../../../services/storage/types'
import i18n from '../../../translations/i18n'
import { Apartment } from '../../../types/apartments'
import { Showing } from '../../../types/showings'
import { IndexedApplications } from '../../../types/states'
import { User } from '../../../types/users'
import ShowingsList from '../../Showings/Overview/ShowingsList'
import { AddressAndMedia, ApartmentInfo } from './Containers'
import PaymentPopup from '../../PayForPublish/PaymentPopup'
import Dialog from '../../Dialog'
import { navigate } from '../../../actions/routes'
import { useDispatch } from 'react-redux';
import Suggest from '../Stepper/Steps/Suggest'

const styles = ({ breakpoints }: Theme) => ({
  primaryBtn: {
    backgroundColor: '#94004A',
    padding: '8px',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  root: {
    backgroundColor: 'inherit',
    width: 'auto' as any
  },
  title: {
    textAlign: 'center' as any,
    margin: '0.5em 0.5em 0.1em 0.35em'
  },
  infoTitle: {
    paddingBottom: '20px',
    textAlign: 'left' as any
  },
  centerTitle: {
    textAlign: 'center' as any
  },
  leftTitle: {
    textAlign: 'left' as any,
    padding: '10px 5px 0px 0'
  },
  rightTitle: {
    textAlign: 'right' as any,
    padding: '10px 5px 0px 0'
  },
  suggestContainer: {
    float: 'right' as const,
    [breakpoints.down('md')]: {
      float: 'none' as const
    }
  },
  mediaContainer: {
    padding: '0 40px 20px 10px',
    [breakpoints.down('md')]: {
      padding: '0 40px 20px 30px'
    },
    [breakpoints.down('xs')]: {
      padding: '0 0 20px 0'
    }
  },
  textContainer: {
    padding: '0',
    textAlign: 'left' as any
  },
  informationContainer: {
    maxWidth: '100%',
    marginBottom: '40px'
  },
  informationRigthSideContainer: {
    flexBasis: 'initial',
    paddingTop: '30px'
  },
  calendar: {
    paddingTop: '10px'
  },
  reserved: {
    backgroundColor: '#f50057',
    borderRadius: '40px'
  },
  addressAndMedia: {
    padding: '8px',
    [breakpoints.down('sm')]: {
      padding: '0'
    }
  },
  addressAndMediaTitle: {
    padding: '8px 0px 8px'
  },
  line: {
    margin: '0',
    padding: '0',
    width: '100%',
    borderBottom: '1px solid #E5E5E5'
  },
  cancelApartment: {
    backgroundColor: '#fff',
    marginBottom: '10px',
    color: '#ff0000',
    border: '1px solid #ff0000',
    padding: '8px',
    width: '100%',
    fontSize: ' 0.8125rem',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#c30e0d',
      border: '1px solid #c30e0d',
      boxShadow: 'none'
    }
  },
  startMarketing: {
    backgroundColor: '#94004A',
    color: '#fff',
    width: '100%',
    marginBottom: '10px',
    border: '1px solid #94004A',
    padding: '8px',
    fontSize: ' 0.8125rem',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#670033',
      //color: '#670033',
      border: '1px solid #670033',
      boxShadow: 'none'
    }
  },
  followUpButton: {
    textTransform: 'uppercase' as const,
    width: '100%'
  },
  disabled: {
    border: 'none'
  },
  mt20: {
    marginTop: '20px'
  },

  //STYLES FOR END RENT DIALOG

  acceptBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '25px 18px',
    gap: '12px',
    width: '100%',
    //maxWidth: 600,
    background: '#F7F8F9',
    borderRadius: 20,
    marginTop: 6,
    marginBottom: 8,
    [breakpoints.down('xs')]: {
      padding: '16px 16px',
      maxWidth: '100%'
    }
  },
  digivakuusFaqButton: {
    marginTop: 8,
    marginLeft: 0,
    padding: 0,
    fontSize: 17,
    textTransform: 'none' as const,
    textDecoration: 'underline',
    fontWeight: 600,
    color: '#94004A',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  digivakuusFaqInlineWrapper: {
    display: 'flex',
    width: '100%',
    marginTop: 4
  },

  // NEW — row holding the checkbox and text
  acceptRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 16,
    width: '100%'
  },

  // NEW — custom checkbox styling (30x30, brand color)
  checkboxRoot: {
    width: 30,
    height: 30,
    padding: 0,
    margin: 0,
    color: '#94004A',
    '&$checkboxChecked': {
      color: '#94004A'
    }
  },
  checkboxChecked: {},

  // NEW — label text styles from your spec, but responsive
  acceptTexts: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    color: "#000"
  },
  acceptHeader: {
    fontFamily: "Circular Std, Inter, system-ui, Arial, sans-serif",
    fontWeight: 700,
    fontSize: '18px',
    marginTop: "2px",
    //fontSize: 18,
    lineHeight: "24px",
  },
  acceptText: {
    fontFamily: "CircularRegular, Inter, system-ui, Arial, sans-serif",
    //fontSize: 16,
    lineHeight: "1.5",
    marginTop: 22,
    color: "#2F2F2F",
    fontSize: '16px',
    fontWeight: 400,
    whiteSpace: 'pre-line'
  },
  cashbackBox: {
    marginTop: 16,
    marginLeft: '-5px',
    padding: '12px 16px',
    borderRadius: 16,
    backgroundColor: '#FFFFFF',
    border: '1px solid #94004A'
  },
  cashbackTitle: {
    fontFamily: "Circular Std, Inter, system-ui, Arial, sans-serif",
    fontWeight: 700,
    fontSize: 16,
    color: '#94004A'
  },
  cashbackText: {
    marginTop: 4,
    fontFamily: "CircularRegular, Inter, system-ui, Arial, sans-serif",
    fontSize: 16,
    lineHeight: "1.5",
    color: '#5C5C5C'
  }
})

interface ApartmentInformationProps extends WithStyles {
  apartment: Apartment
  user: User | undefined
  futureShowings: Showing[]
  files: BucketObject[]
  t: i18n.TFunction
  isAdmin: boolean
  deleteShowing: (args: DeleteShowingArgs) => void
  updateStatus: UpdateStatus
  applications: IndexedApplications
}

const ApartmentInformation = ({
  t,
  classes,
  apartment,
  user,
  files,
  futureShowings,
  isAdmin,
  deleteShowing,
  updateStatus,
  applications
}: ApartmentInformationProps) => {


  const [isLoading, setIsLoading] = useState({ loading: false, func: '' })

  const dispatch = useDispatch();

  const redirectToPaymentPage = () => {
    dispatch(navigate(`/users/${user.userId}/apartments/${apartment.apartmentId}/payment`));
  };

  return (
    <Grid
      container
      item
      className={classes.root}
      md={12}
      spacing={0}
      justify='space-between'
      style={{ overflow: "hidden" }}
    >
      {(!apartment?.information || !apartment?.confirmation) && (
        <Grid item xs={12} sm={8}>
          <Typography variant='h4' className={classes.title}>
            {t('apartment.list.emptyApartment')}
          </Typography>
        </Grid>
      )}
      {apartment?.information?.address && (
        <Fragment>
          <Grid item xs={12} sm={12} lg={7} className={classes.mediaContainer}>
            <Grid container direction='column'>
              <AddressAndMedia
                t={t}
                files={files}
                classes={classes}
                apartment={apartment}
              />
            </Grid>
            {futureShowings.length > 0 && isAdmin && (
              <Grid item xs={12} sm={8} className={classes.informationContainer}>
                <div className={classes.line} />
                <ShowingsList
                  t={t}
                  showings={futureShowings}
                  useCase='confirmed'
                  deleteShowing={deleteShowing}
                />
                <div className={classes.line} />
                <ShowingsList
                  t={t}
                  showings={futureShowings}
                  useCase='waiting'
                  deleteShowing={deleteShowing}
                />
              </Grid>
            )}
            <Hidden mdDown>
              <Grid item xs={12} className={classes.informationContainer}>
                <Typography className={classes.infoTitle} variant='h5'>
                  {t('apartment.list.information.notes')}
                </Typography>
                <Typography variant='body1'>
                  <pre className='MuiTypography-root MuiTypography-body1'>
                    {apartment?.information?.notes || ''}
                  </pre>
                </Typography>
              </Grid>
              {apartment?.status === 'marketing' && (
                <Grid item xs={12} className={classes.informationContainer}>
                  <Typography className={classes.infoTitle} variant='h5'>
                    {t('apartment.list.information.listingVisibility')}
                  </Typography>
                  <Suggest alignLeftOnDesktop
                    content={t('apartment.listingVisibilityHelper')}
                    padding='0px 0px 20px 0px'
                    containerMaxWidth='100%'
                    contentMaxWidth='100%'
                  />
                  <Dialog
                    dialogId='PaymentPopup'
                    //disabled={isApartmentCancelledDisabled(status)}
                    fullScreenDialogMobile={true}
                    color='primary'
                    size='large'
                    maxWidth='md'
                    //title={t('apartments.cancel.label')}
                    buttonLabel={
                      isLoading.loading && isLoading.func === 'cancel' ? (
                        <CircularProgress
                          size={23}
                          style={{ color: '#94004A' }}
                        />
                      ) : (
                        t('apartment.refreshOnPlatforms')
                      )
                    }
                    buttonClassName={classes.startMarketing}
                    Content={
                      <PaymentPopup
                        productTags={['refreshOnPlatforms']}
                        headertext={t('paymentPopup.headerTexts.refreshOnPlatforms')}
                        infotext={t('paymentPopup.suggestTexts.refreshOnPlatforms')}
                        apartment={apartment}
                      />
                    }
                  />
                </Grid>
              )}
                {/* <Typography variant='body1'>
                <pre className='MuiTypography-root MuiTypography-body1'>
                  {apartment?.information?.damages || ''}
                </pre>
              </Typography> */}
              {/* <Grid item xs={12} className={classes.informationContainer}>
              <Typography className={classes.infoTitle} variant='h5'>
                {t('apartment.list.information.renovations')}
              </Typography>
              <Typography variant='body1'>
                <pre className='MuiTypography-root MuiTypography-body1'>
                  {apartment?.information?.renovations || ''}
                </pre>
              </Typography>
            </Grid> */}
            </Hidden>
            {/* <Grid item xs={12} className={classes.informationContainer}>
            <Typography className={classes.infoTitle} variant='h5'>
              {t('apartment.list.information.energyCertification')}
            </Typography>
            <Typography variant='body1'>
              {t(
                apartment?.information?.energyCertification === 'default'
                  ? 'apartment.list.information.energyCertNotRequired'
                  : apartment?.information?.energyCertification || ''
              )}
            </Typography>
          </Grid> */}
          </Grid>
          {/* <Grid
          container
          direction='column'
          item
          sm={12}
          md={12}
          lg={5}
          className={classes.textContainer}
          justify='space-between'
        > */}
          <ApartmentInfo
            t={t}
            classes={classes}
            apartment={apartment}
            user={user}
            updateStatus={updateStatus}
            isAdmin={isAdmin}
            applications={applications}
          />
          {/* </Grid> */}
        </Fragment>
      )}
    </Grid>
  )
}

export default withStyles(styles)(ApartmentInformation)
